import { Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react'
import { useRef } from 'react'
import { AccountItem } from 'src/interfaces/api/GetAccountItems'

type Props = {
  onClick: (accountItemId: number) => void
  accountItems: AccountItem[]
  selectedAccountItemId: number
}
export const AccountItemSelectMenu: React.VFC<Props> = ({
  onClick,
  selectedAccountItemId,
  accountItems
}) => {
  const itemsRef = useRef<Array<HTMLButtonElement | null>>(
    [...Array(accountItems.length)].map((el) => null)
  )
  return (
    <Menu placement="bottom-start" autoSelect={false} isLazy={false}>
      <MenuButton
        onClick={() => {
          const index = accountItems.findIndex(
            (item) => item.id === selectedAccountItemId
          )
          const evt = document.createEvent('HTMLEvents')
          evt.initEvent('mouseover', true, true)

          itemsRef.current[index]?.dispatchEvent(evt)
        }}
        borderRadius="8px"
        h="44px"
        w="100%"
        py="16px"
        textAlign="center"
        color="primary.purple"
        fontWeight={700}
        fontSize="12px"
        bgColor="purple.100"
      >
        {accountItems.find((item) => item.id === selectedAccountItemId)?.name ||
          accountItems[0]}
      </MenuButton>
      <MenuList fontSize="14px" lineHeight={1} p="0">
        {accountItems.map((accountItem, accountItemIndex) => (
          <MenuItem
            key={accountItem.id}
            ref={(el) => {
              itemsRef.current[accountItemIndex] = el
            }}
            value={accountItem.id}
            fontWeight={400}
            px="20px"
            py="16px"
            h="46px"
            color="gray.800"
            onClick={() => {
              onClick(accountItem.id)
            }}
          >
            {accountItem.name}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  )
}
